export function sort<T>(array: Array<T>, compareFn?: (a: T, b: T) => number): Array<T> {
    // tslint:disable-next-line: no-array-mutation
    return [...array].sort(compareFn);
}
